import type { RecipeMeal, SimpleRecipeMeal } from "../services/backendTypes";

export function getTestIDForRecipeMeal(recipeMeal: RecipeMeal): string {
  return `planned-recipeMeal-${recipeMeal.recipe_template.source_provider}-${
    recipeMeal.recipe_template.id || "MISSING_ID"
  }`;
}

export function getTestIDForSimpleRecipeMeal(simpleRecipeMeal: SimpleRecipeMeal): string {
  return `planned-simpleRecipeMeal-${simpleRecipeMeal.id || "MISSING_ID"}`;
}
